/**
 * Google Analytics 4 event tracking utility.
 * Uses the global gtag function injected by useAnalyticsScripts or GTM in index.html.
 * Safe to call even if GA is not loaded (no-op).
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

interface TrackEventParams {
  /** GA4 event name (e.g. "cta_click") */
  action: string;
  /** Event category for grouping */
  category: string;
  /** Human-readable label */
  label: string;
  /** Optional numeric value */
  value?: number;
  /** Any extra GA4 parameters */
  [key: string]: unknown;
}

export function trackEvent({ action, category, label, value, ...extra }: TrackEventParams) {
  // gtag approach
  if (typeof window.gtag === "function") {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value,
      ...extra,
    });
  }

  // GTM dataLayer fallback
  if (window.dataLayer) {
    window.dataLayer.push({
      event: action,
      event_category: category,
      event_label: label,
      value,
      ...extra,
    });
  }
}
